import { Navigate } from "react-router-dom";
import { AuthStatus, useAuthStore } from "../modules/auth/store/auth.store";

export default function ProtectedSite({ children }: { children: any }) {
  const status = useAuthStore((state) => state.status);
  if (status !== AuthStatus.LOGGED_IN && status !== AuthStatus.LOGGED_OUT) {
    return <Navigate to="/flashboard" replace />;
  }

  return children;
}
